
import { Component, Vue } from 'vue-property-decorator';
// 获取操作系统
const getOsType = () => {
  const ua = navigator.userAgent.toLowerCase();
  const matches = ua.match(/iphone|ipad|android/g);
  if (matches?.length) {
    return matches[0];
  }
  return 'other';
};

@Component
export default class WxPhoneX extends Vue {
  isIphonex = false;
  tryCount=0;
  maxCount=100;
  curHeight=window.innerHeight;
  checkIsIphoneX() {
    console.log('checkIsIphoneX', getOsType(), window.innerHeight, window.screen.height);
    // x xs xr innerheight都高过720
    // 有导航栏时innerheight会低于720 ==> 有问题，ios h5 底部有导航的时候，就不足 720，滚动时候导航会出现会消失
    // 因为现在 iPhone 在 iPhone X 之后的机型都需要适配，所以可以对 X 以后的机型统一处理，我们可以认为这系列手机的特征是 ios + 长脸
    // return getOsType() === 'iphone' && window.innerHeight > 720;
    return getOsType() === 'iphone' && window.screen.height >= 720;
  }

  created() {
    this.isIphonex = this.checkIsIphoneX();
  }
}
